var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow"},[(_vm.pageUrl)?_c('iframe',{attrs:{"src":_vm.pageUrl,"width":"100%","height":"100%"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }